import { render, staticRenderFns } from "./toOrderMeal.vue?vue&type=template&id=45a42add&scoped=true&"
import script from "./toOrderMeal.vue?vue&type=script&lang=js&"
export * from "./toOrderMeal.vue?vue&type=script&lang=js&"
import style0 from "./toOrderMeal.vue?vue&type=style&index=0&id=45a42add&prod&lang=less&scoped=true&"
import style1 from "./toOrderMeal.vue?vue&type=style&index=1&id=45a42add&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a42add",
  null
  
)

export default component.exports